import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCode.Save.IRequest;
type Response = Api.Core.LossCode.Save.IResponse;
type Headers = Api.Core.LossCode.Save.IHeaders;
const url = '/api/Claims/LossCode';
export default async function lossCodeSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
